import {
  type GetMeasuredRolloutQueryParams,
  getMeasuredRollout,
} from '@gonfalon/openapi/operations/getMeasuredRollout';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

/**
 * @deprecated Use `createQueryOptions` with the OpenAPI operation directly instead.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const measuredRollouts = createQueryKeys('measured-rollouts', {
  detail: ({
    projectKey,
    flagKey,
    environmentKey,
    measuredRolloutId,
    params,
  }: {
    projectKey: string;
    flagKey: string;
    environmentKey: string;
    measuredRolloutId: string;
    params?: GetMeasuredRolloutQueryParams;
  }) => ({
    queryKey: params
      ? [projectKey, flagKey, environmentKey, measuredRolloutId, params]
      : [projectKey, flagKey, environmentKey, measuredRolloutId],
    queryFn: async () =>
      reactQueryResponseAdapter(
        getMeasuredRollout({
          flagKey,
          projectKey,
          environmentKey,
          measuredRolloutId,
          query: {
            ...params,
          },
        }),
      ),
  }),
});

export const measuredRolloutsDetail = measuredRollouts.detail;
export const measuredRolloutsDetailRoot = measuredRollouts.detail._def;
import { getMeasuredRollouts } from '@gonfalon/openapi/operations/getMeasuredRollouts';
import { getReleaseGuardianEntitlement } from '@gonfalon/openapi/operations/getReleaseGuardianEntitlement';
import { internalGetAutomatedReleaseExemplarErrors } from '@gonfalon/openapi/operations/internalGetAutomatedReleaseExemplarErrors';
import { internalGetAutomatedReleaseMetricResults } from '@gonfalon/openapi/operations/internalGetAutomatedReleaseMetricResults';
import { internalGetAutomatedReleaseMetricTimeSeriesResults } from '@gonfalon/openapi/operations/internalGetAutomatedReleaseMetricTimeSeriesResults';
import { internalGetAutomatedReleaseRecommendedDuration } from '@gonfalon/openapi/operations/internalGetAutomatedReleaseRecommendedDuration';
import { internalGetBulkMetricDiagnostics } from '@gonfalon/openapi/operations/internalGetBulkMetricDiagnostics';
import { internalGetFlagDiagnostics } from '@gonfalon/openapi/operations/internalGetFlagDiagnostics';
import { internalGetMetricDiagnostic } from '@gonfalon/openapi/operations/internalGetMetricDiagnostic';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getMeasuredRolloutsQuery = createQueryOptions(getMeasuredRollouts);

export const getReleaseGuardianEntitlementsQuery = createQueryOptions(getReleaseGuardianEntitlement);

export const getFlagDiagnosticsQuery = createQueryOptions(internalGetFlagDiagnostics);
export const getMetricDiagnosticsQuery = createQueryOptions(internalGetMetricDiagnostic);
export const getBulkMetricDiagnosticsQuery = createQueryOptions(internalGetBulkMetricDiagnostics);
export const getRecommendedRolloutDurationQuery = createQueryOptions(internalGetAutomatedReleaseRecommendedDuration);
export const getExemplarErrorsQuery = createQueryOptions(internalGetAutomatedReleaseExemplarErrors);
export const getAutomatedReleaseMetricResultsQuery = createQueryOptions(internalGetAutomatedReleaseMetricResults);
export const getAutomatedReleaseMetricTimeSeriesResultsQuery = createQueryOptions(
  internalGetAutomatedReleaseMetricTimeSeriesResults,
);

import { internalGetAudiencePhaseReleasesForFlag } from '@gonfalon/openapi/operations/internalGetAudiencePhaseReleasesForFlag';
import { internalGetAutomatedRelease } from '@gonfalon/openapi/operations/internalGetAutomatedRelease';
import { internalGetAutomatedReleases } from '@gonfalon/openapi/operations/internalGetAutomatedReleases';

export const getAutomatedReleaseQuery = createQueryOptions(internalGetAutomatedRelease);
export const getAutomatedReleasesQuery = createQueryOptions(internalGetAutomatedReleases);

/** Lists the audience-phase release groupings for a flag in an environment: each group maps a release id to its ordered `phaseRuleIds` (audience order, oldest first). The targeting page uses this to group contiguous wire rules into a single multi-phase release block. */
export const getAudiencePhaseReleasesForFlagQuery = createQueryOptions(internalGetAudiencePhaseReleasesForFlag);
